export const fmt = (n: number): string =>
  Math.round(n).toLocaleString("ru-RU");

export const fmt1 = (n: number): string =>
  n.toLocaleString("ru-RU", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/** unix-секунды → "дд.мм чч:мм" в локальном времени устройства. */
export const fmtDateTimeShort = (ts: number): string => {
  const d = new Date(ts * 1000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
};
